<template>
    <div class="hamburger__container">
        <div class="hamburgerHeader">
            <div class="hamburgerHeader__left">
                <button class="hamburgerHeader__left__button" @click="toggleShow">
                    <span class="hamburger__close"></span>
                    <p class="hamburger__close-text">
                        {{ $t('HAMBURGER_CLOSE') }}
                    </p>
                </button>
            </div>
            <div class="hamburgerHeader__center">
                <!-- Small logo -->
                <router-link :to="{ name: 'home'}">
                    <div @click="$emit('closed')">
                        <img
                            class="hamburgerHeader__centerLogo"
                            src="@/assets/images/logos/freddies_flowers_logo_horizontal.svg"
                            alt="Freddie's Flowers"/>
                    </div>
                </router-link>
            </div>
            <div class="hamburgerHeader__right">
                <div @click="$emit('closed')">
                    <login-link></login-link>
                </div>
            </div>
        </div>
        <hr class="bg-black mt-2 mx-4 h-px">

        <div v-if="!isPage(['register', 'account'])" class="hamburger__landing-buttons__container">
            <hr class="hamburger__divider">
            <div class="hamburger__landing-buttons">
                <div @click="toggleShow(); go(button.route)" :key="index" v-for="(button, index) in filteredButtons">
                    <nav-button :button="button" class="hamburger__landing-button"/>
                </div>
            </div>
        </div>

        <hr class="hamburger__divider">

        <div class="hamburger__row mx-auto w-full">

            <div class="mb-3 mt-5 text-center w-full">
                <h3>{{ $t('HAMBURGER_HELP') }}</h3>
            </div>

            <div class="mb-3 mt-5 text-center w-full lg:hidden">
                <language-switcher></language-switcher>
            </div>

            <!-- useful links -->
            <div class="hamburgerHelp__container">
                <contact-us
                    :faqsLink="true"
                    @closed="toggleShow"/>
            </div>
        </div>
        <!-- <div class="country_select">
            <country-switch-dropdown />
        </div> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import CountrySwitchDropdown from '@/components/structure/navigation/CountrySwitchDropdown';
import NavButton from '@/components/structure/navigation/navigation/NavButton';
import LoginLink from '@/components/structure/navigation/navigation/LogInLink';
import ContactUs from '@/components/structure/navigation/navigation/ContactUs';
import LanguageSwitcher from '@/components/structure/navigation/navigation/LanguageSwitcher';

export default {
    name: 'Hamburger',
    computed: {
        ...mapGetters({
            buttons: 'nav/getButtons',
            isUserLoggedIn: 'auth/isUserLoggedIn',
        }),
        filteredButtons() {
            const status = (this.isUserLoggedIn ? 'loggedIn' : 'loggedOut');
            return this.buttons.filter(button => button[status]);
        },
    },
    methods: {
        go(route) {
            this.$router.push({ name: route });
        },
        toggleShow() {
            this.$emit('closed');
        },
        isPage(pageArr) {
            const pageRoot = this.$route.name.split('.')[0];
            return pageArr.find(page => pageRoot === page);
        },

    },
    components: {
        ContactUs,
        LoginLink,
        LanguageSwitcher,
        NavButton,
        // CountrySwitchDropdown,
    },
};
</script>

<style lang="scss">
    .country_select {
        margin: 0 auto;
        width: fit-content;
    }
    .hamburger__divider {
        margin: 8px 16px 0;
        background-color: black;
        height: 1px;
    }
    .hamburger__landing-buttons__container {
        width: 100%;
    }
    .hamburger__landing-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 16px 0;
    }
    .hamburger__landing-button {
        text-align: center;
        text-transform: uppercase;
        margin: 0 24px;
        img {
            margin: 0 auto;
            height: 45px;
            width: 45px;
        }
        h5 {
            font-size: 12px;
            margin: 8px 0 0;
        }
    }
    @media (min-width: 1024px) {
        .hamburger__landing-buttons__container {
            display: none;
        }
    }
</style>
